module.exports = __webpack_public_path__ + "img/5.a467e498.png";